import { z } from 'zod';

/**
 * postMessage contract (child → parent, one-way) per the ESS integration
 * spec: the portal sends exactly one success or error message; ESS validates
 * `event.origin` and ignores any other `type` values.
 */
export const faceCaptureSuccessMessageSchema = z.object({
  type: z.literal('face-capture:success'),
  /** Base64 JPEG data URL, forwarded verbatim by ESS to `verify-image` / `enroll`. */
  image_base64: z.string().startsWith('data:image/jpeg;base64,'),
});

export const faceCaptureErrorMessageSchema = z.object({
  type: z.literal('face-capture:error'),
  /** Human-readable — ESS shows this in an error notification as-is. */
  message: z.string().min(1),
});

export const faceCaptureMessageSchema = z.union([
  faceCaptureSuccessMessageSchema,
  faceCaptureErrorMessageSchema,
]);

export type FaceCaptureSuccessMessage = z.infer<typeof faceCaptureSuccessMessageSchema>;
export type FaceCaptureErrorMessage = z.infer<typeof faceCaptureErrorMessageSchema>;
export type FaceCaptureMessage = z.infer<typeof faceCaptureMessageSchema>;
